<script setup lang="ts">
import { XCircleIcon } from '@heroicons/vue/24/solid';
</script>

<template>
  <div class="flex flex-col items-center justify-center py-12">
    <div class="flex flex-col items-center text-center">
      <XCircleIcon class="mb-4 h-16 w-16 text-red-600" />
      <h4 class="mb-2 text-xl font-semibold text-red-900">Verification Rejected</h4>
      <p class="mb-6 max-w-md text-sm text-gray-600">
        Your identity verification has been rejected. This may be due to document quality, identity
        mismatch, or other verification requirements not being met.
      </p>
    </div>
  </div>
</template>
